export const UPDATE_MAIN_LIST = 'UPDATE_MAIN_LIST';

export enum EventsInvite {
  StudentsOnly = 1,
  ParentsMustAttend = 2,
  ParentsAreWelcome = 3,
}
